// @ts-nocheck
import { Table } from "@shared/antd/table";
import { Modal } from "@shared/antd/modal";
import React from 'react';
import {IntlShape, useIntl} from "react-intl";
import {TableAdaptive} from "./ui/table-adaptive";

interface TransportDetailTableProps<T> {
  dataTable: T[]
  handleModal?: (isVisible: boolean) => void
  isVisible?: boolean
  selectedElement?: T
  setSelectedElement?: (item: T | null) => void
  getTableFields?: (intl: IntlShape, selectedElement: any, setSelectedElement: any) => any[]
  title: string
  isLoading?: boolean
  header?: React.ReactNode
}

export const SelectTableWithRadio = <T extends { id?: any | null }>(
  props: TransportDetailTableProps<T>
) => {
  const {
    dataTable,
    isVisible,
    handleModal,
    selectedElement,
    setSelectedElement,
    getTableFields,
    title,
    isLoading,
    header
  } = props
  const intl = useIntl();
  const [element, setElement] = React.useState<T | null>(null);

  const handleRowClick = (record: T) => ({
    onClick: () => {
      setElement(record)
    },
    style: {
      backgroundColor: selectedElement?.id === record.id ? "#e6f7ff" : "inherit",
      cursor: "pointer",
    },
  });

  const onOk = () => {
    setSelectedElement(element)
    handleModal(false)
  }
  const onCancel = () => {
    setElement(null)
    handleModal(false)
  }

  return (
    <Modal
      title={title}
      width={"90%"}
      style={{height: "770px"}}
      closable={false}
      visible={isVisible}
      onOk={onOk}
      onCancel={onCancel}
    >
      {header}
      <TableAdaptive<T>
        loading={isLoading}
        rowKey={(_) => _.id}
        onRow={handleRowClick}
        dataSource={dataTable}
        columns={getTableFields(intl, selectedElement, setSelectedElement)}
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
        }}
        rowClassName={(record) => (selectedElement?.id === record.id ? 'selected-row' : '')}
      />
    </Modal>

  );
};


